import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {computed, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    BlogPostDtoLightweight,
    GetRecentPostsForWidgetRequest
} from "@/dtos";

import BlogPostCard from "./BlogPostCard.vue";
import BlogPostCardMinimal from "./BlogPostCardMinimal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RecentPostsWidget',
  props: {
    numOfPosts: {
        type: Number,
        default: 6
    },
    use: {
        type: String,
        default: "card"
    },
},
  setup(__props) {

// @ts-ignore
const props = __props

const use = ref(props.use);

let recentPosts: Ref<BlogPostDtoLightweight[]> = ref([]);

onMounted(async () => {
    await getRecentPostsForWidget();
});

const getRecentPostsForWidget = async () => {
    await client.get<any>(new GetRecentPostsForWidgetRequest({ pageSize: props.numOfPosts}))
        .then(response => {
            recentPosts.value = response.results;
        });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recentPosts), (post) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "relative",
      key: post.id
    }, [
      (use.value === 'minimal')
        ? (_openBlock(), _createBlock(BlogPostCardMinimal, {
            key: 0,
            post: post
          }, null, 8, ["post"]))
        : (_openBlock(), _createBlock(BlogPostCard, {
            key: 1,
            post: post
          }, null, 8, ["post"]))
    ]))
  }), 128))
}
}

})